import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class UsersLoginModule {
    constructor() {
        this.users = [];
        this.count = 0;
        this.axiosError = null;
    }
    setItems(users) {
        this.users = users;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.users;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.usersLogin.get(options);
            this.setItems(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], UsersLoginModule.prototype, "users", void 0);
__decorate([
    State()
], UsersLoginModule.prototype, "count", void 0);
__decorate([
    State()
], UsersLoginModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], UsersLoginModule.prototype, "setItems", null);
__decorate([
    Mutation()
], UsersLoginModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], UsersLoginModule.prototype, "setError", null);
__decorate([
    Getter()
], UsersLoginModule.prototype, "list", null);
__decorate([
    Getter()
], UsersLoginModule.prototype, "total", null);
__decorate([
    Getter()
], UsersLoginModule.prototype, "errorList", null);
__decorate([
    Action()
], UsersLoginModule.prototype, "get", null);
